var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shippingDetail"},[_c('common',{ref:"common",attrs:{"injectData":_vm.commonData}}),_c('tag',{ref:"tag",attrs:{"injectData":_vm.commonData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }